<template>
  <ul class="add-list list">
    <li class="combine-item">
      <button type="button"
              @click="showAdd"
              class="list-item">
        {{$t('things.add.thing')}}
        <thing-icon :fill="'rgba(0, 82, 127, .4)'"></thing-icon>
      </button>
    </li>
    <li v-if="$route.name !== 'things'"
        class="combine-item">
      <button type="button"
              @click="showAddThing"
              class="list-item">
        {{$t('projects.project.addThing')}}
        <plusIcon :fill="'rgba(0, 82, 127, .4)'"></plusIcon>
      </button>
    </li>
    <li class="combine-item">
      <button type="button"
              @click="showAdd('multi')"
              class="list-item">
        {{$t('things.add.multi')}}
        <virtual-icon :fill="'rgba(0, 82, 127, .4)'"></virtual-icon>
      </button>
    </li>
    <!--<li class="combine-item" v-if="!isVirtual">
      <button type="button"
              @click="showAdd('group')"
              class="list-item">
        {{$t('things.add.group')}}
        <group-icon :fill="'rgba(0, 82, 127, .4)'"></group-icon>
      </button>
    </li>-->
  </ul>
</template>

<script>
  import thingIcon from '../../../../Svg/things/nagThing'
  import virtualIcon from '../../../../Svg/things/navVirtual'
  import groupIcon from '../../../../Svg/things/navGroup'
  import {mapMutations} from 'vuex'
  import {showOverlay} from "../../../../../mixins/utils/showOverlay";
  import plusIcon from  '../../../../Svg/plusIcon'

  export default {
    name: 'addList',
    props: {
      isVirtual: {
        type: Boolean,
        default: false
      }
    },
    mixins: [showOverlay],
    components: {
      thingIcon,
      virtualIcon,
      groupIcon,
      plusIcon
    },
    methods: {
      ...mapMutations({
        showAddThingPopup: 'popups/addThing/SET_SHOW',
        setType: 'popups/addThing/SET_TYPE',
        showAddThingMultiPopup: 'projects/SET_ADD_THING_IN_PROJECT',
      }),
      showAddThing(param) {
        this.showOverlay(true);
        this.showAddThingMultiPopup(true);
      },
      showAdd(param) {
        this.showOverlay(true);
        this.showAddThingPopup(true);

        switch (param) {
          case ('multi'): {this.setType('multi')};
            break;
          /*case('group'): {this.setType('group')};
            break;*/
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.combine-item {
  width: 240px;
}


</style>
